// extracted by mini-css-extract-plugin
module.exports = {"header_campaign":"header_campaign_header_campaign__RPFam"};